import { useDispatch } from "react-redux";
import { useUserTypeInfo } from "../../../../libs/customhooks/useUserTypeInfo";
import General from "../../../../libs/utility/General";
import Platform from "../../../../libs/utility/Platform";
import DrawerWithTitleAndFooter from "../../../components/drawer/DrawerWithTitleAndFooter";
import Icons from "../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../components/icons/constants";
import { setShowOtherAppsDrawer } from "../DashboardSlice";
import styles from './OtherAppsDrawer.styles';

export default function OtherAppsDrawer(){

    const { userType } = useUserTypeInfo();
    const dispatch = useDispatch();

    const handleClose = () => {
		dispatch(setShowOtherAppsDrawer(false));
	};

    let otherAppsList = [
		{
			IconName: VEC_ICON_NAME.FBAR_ONLINE_ICON,
			Text: '',
			onClick: () => { 
				handleClose();
                window.open("https://fbaronline.com/", 'mywindow', 'noopener')
			},
			AllowRole: [],
		},
		{
			IconName: VEC_ICON_NAME.EZ_EXTENSION_ICON,
			Text: '',
			onClick: () => { 
				handleClose();
                window.open("https://ezextension.com/", 'mywindow', 'noopener')
			},
			AllowRole: [],
		},
		{
			IconName: VEC_ICON_NAME.EZ_2290_ICON,
			Text: '',
			onClick: () => { 
				handleClose();
                window.open("https://www.ez2290.com/", 'mywindow', 'noopener')
			},
			AllowRole: [],
		},
	]

	const customStyles = {
		width: Platform.isMobileView() ? "100%" : "350px",
		right: "unset",
		zIndex: "999",
	}

    return <>
        <DrawerWithTitleAndFooter isOpen={true} onCloseCb={handleClose} title={"Our Apps"} customStylesDrawer={customStyles}>
			<div>
				<div style={styles.drawerMenuMainContainer}>
					
					{otherAppsList.map((option) => 

						( General.hasAccessToUserType(userType, option.AllowRole) ? 
							<div
								style={styles.drawerMenuItemContainer}
								onClick={option.onClick}
							>
								<Icons
									familyName={"vec"}
									iconName={option.IconName}
									transformScale={0.6}
								/>
								<span>{option.Text}</span>
							</div>
							:
							<></>
						)
					)}
				</div>
			</div>
		</DrawerWithTitleAndFooter>
    </>
}